import React, { useEffect, useState } from 'react';
import { OrderFulfillmentReducedFragment } from '../../../graphql/fragments/orderFulfillmentReduced.generated';
import { LayoutStoreInstance } from '../../../LayoutStore';
import i18n from '@/utils/i18n';
import {
  IdName,
  OrderFulfillmentFilter,
} from '../../../graphql/generatedTypes';
import { useGetOrderFulfillmentsQuery } from '../../../graphql/queries/getOrderFulfillments.generated';
import OrderFulfillmentFilterForm from './OrderFulfillmentFilterForm';
import OrderFulfillmentsTable, {
  OrderFulfillmentsTableHeaderSort,
} from './OrderFulfillmentsTable';
import { useExportEventAccountOrderFulfillmentsLazyQuery } from '../../../graphql/queries/exportEventAccountOrderFulfillments.generated';
import { Button } from 'reactstrap';
import ClassicLoadingSpinner from '../../../components/LoadingSpinner/ClassicLoadingSpinner';
import { FaDownload } from 'react-icons/fa';
import { ContainerType } from '../OrderFulfillment/Components/OrderFulfillmentAddContainerTypes';
import getAllContainerTypesFromOrderfulfillments from '../OrderFulfillment/Components/functions/getUsedContainerTypesFromOrderfulfillments';

type OrderFulfillmentsTableWithFilterProps = {
  authorizedSigners: IdName[];
  events: IdName[];
  itemLocations: IdName[];
  eventAccounts: IdName[];
  filter: OrderFulfillmentFilter;
  containerTypes?: ContainerType[];
  headers?: OrderFulfillmentsTableHeaderSort[];
};

export const ORDER_FULFILLMENT_PAGE_SIZE = 20;

const OrderFulfillmentsTableWithFilter = ({
  filter: initialFilter,
  authorizedSigners,
  events,
  itemLocations,
  eventAccounts,
  containerTypes,
  headers,
}: OrderFulfillmentsTableWithFilterProps) => {
  const [page, setPage] = useState(1);
  const [orderFulfillments, setOrderFulfillments] = useState<
    OrderFulfillmentReducedFragment[]
  >([]);
  const [total, setTotal] = useState(0);
  const [filter, setFilter] = useState<OrderFulfillmentFilter>({
    ...initialFilter,
  });

  const [exportOrderFulfillments, { loading: exportingOrderFulfillments }] =
    useExportEventAccountOrderFulfillmentsLazyQuery({
      fetchPolicy: 'no-cache',
    });

  const { data, loading, error, refetch } = useGetOrderFulfillmentsQuery({
    variables: {
      skip: 0,
      take: ORDER_FULFILLMENT_PAGE_SIZE,
      filter,
    },
    fetchPolicy: 'no-cache',
  });

  useEffect(() => {
    if (data) {
      setTotal(data.getOrderFulfillments.total);
      setOrderFulfillments(data.getOrderFulfillments.order_fulfillments);
    }
  }, [data]);

  useEffect(() => {
    console.log({
      filter,
    });

    let skip = (page - 1) * ORDER_FULFILLMENT_PAGE_SIZE;
    skip = skip < 0 ? 0 : skip;

    refetch({
      skip,
      take: ORDER_FULFILLMENT_PAGE_SIZE,
      filter,
    });
  }, [page]);

  const handleFilterSubmit = (newFilter: OrderFulfillmentFilter) => {
    console.log({
      newFilter,
    });
    setFilter(newFilter);
    setPage(1);
  };

  if (error) {
    console.log(error);
    LayoutStoreInstance.setError(i18n.t('OrderFulfillment:errorOnLoad'));
  }

  async function downloadOrderFulfillments() {
    const res = await exportOrderFulfillments({
      variables: {
        filter: filter,
      },
    });
    if (res.error || res.data == null) {
      LayoutStoreInstance.setError('Error exporting handouts & returns');
      console.log(error);
    } else if (
      res.data.exportEventAccountOrderFulfillments.startsWith('https')
    ) {
      window.open(res.data.exportEventAccountOrderFulfillments, '_blank');
    } else {
      LayoutStoreInstance.setError(
        res.data.exportEventAccountOrderFulfillments,
      );
    }
  }

  const pageCount = Math.ceil(total / ORDER_FULFILLMENT_PAGE_SIZE);

  const containerTypesUsedInEvent =
    getAllContainerTypesFromOrderfulfillments(orderFulfillments);

  return (
    <div>
      <OrderFulfillmentFilterForm
        handleFilterSubmit={handleFilterSubmit}
        filter={filter}
        authorizedSigners={authorizedSigners}
        events={events}
        itemLocations={itemLocations}
        eventAccounts={eventAccounts}
        containerTypes={containerTypes}
        containerTypesUsedInEvent={containerTypesUsedInEvent}
      />
      <div style={{ clear: 'both' }}></div>
      <h5 className="mt-2 mb-2">{i18n.t('OrderFulfillment:results')}</h5>
      <OrderFulfillmentsTable
        error={error}
        loading={loading}
        setPage={setPage}
        page={page}
        pageCount={pageCount}
        orderFulfillments={orderFulfillments}
        headers={headers}
      />
      <Button
        className="float-end ms-2 mt-2 mb-2"
        onClick={() => downloadOrderFulfillments()}
        disabled={exportingOrderFulfillments}
      >
        {exportingOrderFulfillments ? (
          <ClassicLoadingSpinner />
        ) : (
          <FaDownload />
        )}
        {' ' + i18n.t('Common:download')}
      </Button>
    </div>
  );
};

export default OrderFulfillmentsTableWithFilter;
